<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->

<template>
	<div class="md-grey-page booking booking-view">
    <div class="container-white">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="booking && booking.iam == 'invited' && booking.booking.frontend.indexOf('_feed') !== -1 && !booking.user.mobileConfirmed">
        <!-- SCHEDULE  -->
        <schedule-phase v-if="phase == 'schedule' && booking.booking.status != 'suggested'" :booking="booking"></schedule-phase>
        <!-- CONFIRMATION  -->
        <mobileconfirm-phase :booking="booking" v-else-if="booking.booking.status == 'suggested' || !booking.user.mobileConfirmed"></mobileconfirm-phase>

        <div class="margin-top-60 text-center" v-else>
    			<p class="mdc-theme-primary-dark loading-text">Loading<span>.</span><span>.</span><span>.</span></p>
    		</div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-else>

        <!-- INVITATION  -->
        <invitation-phase v-if="phase == 'invitation'" :booking="booking"></invitation-phase>

        <!-- SCHEDULE  -->
        <schedule-phase v-else-if="phase == 'schedule'" :booking="booking"></schedule-phase>

        <!-- CONFIRMATION  -->
        <confirmation-phase v-else-if="phase == 'confirmation'" :booking="booking"></confirmation-phase>

        <!-- CANCELATION  -->
        <div class="booking__cancellation" v-else-if="booking && booking.booking.status == 'cancelled'">
          <div v-if="booking.iam == 'inviter'">
            We have notified the applicant that the property is no longer available.
            <!-- Your viewing has been cancelled and {{ booking.user.fullName }} has been notified. -->

            <div class="booking__close-btn text-center">
              <a href="javascript:;" @click.prevent="$router.push('/')">Back to BestAgent></a>
            </div>
          </div>
          <div v-if="booking.iam == 'invited'">
            Your viewing has been cancelled and {{ booking.company.companyName ? booking.company.companyName : booking.agent.name }} has been notified.
            <div class="booking__close-btn text-center">
              <a href="javascript:;" @click.prevent="closethis()">Close ></a>
            </div>
          </div>
          <!--
            <div class="booking__close-btn text-center">
              <a href="javascript:;" @click.prevent="closethis()">Close></a>
            </div>
          -->
        </div>

        <div class="margin-top-60 text-center" v-else>
    			<p class="mdc-theme-primary-dark loading-text">Loading<span>.</span><span>.</span><span>.</span></p>
    		</div>

      </div>
    </div>
	</div>
</template>

<script>
import api from '@/libs/api.js';
import invitationPhase from '../components/booking/invitation.vue';
import schedulePhase from '../components/booking/schedule.vue';
import confirmationPhase from '../components/booking/confirmation.vue';
import mobileconfirmPhase from '../components/booking/confirmmobile.vue';
import OptionButtons from '../components/OptionButtons.vue';

export default {
	data: function() {
	 return {
     trackId: undefined,
     userId: undefined,
     booking: undefined,
     phase: undefined, // invitation, schedule, confirmation, closed
     action: undefined,
     params: undefined,
   }
 },
 components: {
   'invitation-phase': invitationPhase,
   'schedule-phase': schedulePhase,
   'confirmation-phase': confirmationPhase,
   'mobileconfirm-phase': mobileconfirmPhase
 },

 created: async function() {
   this.trackId = this.$route.params.trackId;
   this.userId = this.$route.params.userId;
   this.action = this.$route.params.action;
   this.params = this.$route.params.params;

   if (!this.trackId || !this.userId) {
     window.location.pathname = '/';
     return false;
   }

   try {
     await this.getBooking();
   } catch(e) {
     window.location.pathname = '/';
   }
 },
 methods: {
   closethis() {
     window.open('', '_self').close();
     window.top.close();
   },
   async getBooking() {
     let booking = await api({endpoint: this.config.services.booking, path: '/info/'+this.trackId+'/'+this.userId, method: 'GET'});
     if (booking) {
       if (this.action && booking.booking && booking.booking.status == 'cancelled' && this.action == 'reopen') { // reopen
         await api({endpoint: this.config.services.booking, path: '/reopen/'+this.trackId+'/'+this.userId, method: 'GET'});
         window.location.pathname = '/booking/'+this.trackId+'/'+this.userId;
         return false;
       }
     }

     if (!booking || !booking || !booking.booking || !booking.booking.trackId || booking.booking.phase == 'expired') {
       window.location.pathname = '/';
       return false;
     }
     this.booking = booking;
     this.phase = this.booking.booking.phase;
   }
 }
}
</script>



// WEBPACK FOOTER //
// src/pages/BookingView.vue